{
  "processing": "Przetwarzanie weryfikacji...",
  "loadingIframe": "Ładowanie weryfikacji tożsamości...",
  "issueTitle": "Problem z weryfikacją tożsamości",
  "notConfigured": "Weryfikacja tożsamości nie jest prawidłowo skonfigurowana dla tego magazynu.",
  "notSuccessful": "Weryfikacja tożsamości nie powiodła się. Spróbuj ponownie lub skontaktuj się z magazynem.",
  "couldNotCompleteProceed": "Weryfikacja tożsamości nie mogła zostać ukończona, ale możesz kontynuować zameldowanie.",
  "processFailed": "Przetwarzanie weryfikacji tożsamości nie powiodło się. Spróbuj ponownie.",
  "processingFailedProceed": "Przetwarzanie weryfikacji tożsamości nie powiodło się, ale możesz kontynuować zameldowanie.",
  "genericError": "Wystąpił błąd podczas weryfikacji tożsamości. Spróbuj ponownie.",
  "issueProceed": "Weryfikacja tożsamości napotkała problem, ale możesz kontynuować zameldowanie.",
  "requiredTryAgain": "Weryfikacja tożsamości jest wymagana do ukończenia zameldowania. Spróbuj ponownie.",
  "checkInFailedTitle": "Nie można się zameldować",
  "checkInFailedMessage": "Nie udało się zweryfikować Twojego dokumentu tożsamości"
}
